import BlogPage from './[page]'

export {getStaticProps} from './[page]'

export default BlogPage
